import React from "react";

const parceiros = [
    { src: "/Images/Parceiros/R31.png", alt: "Parceiro R31", link: "https://bit.ly/3rpN2T8/" },
    { src: "/Images/Parceiros/Sintel.png", alt: "Parceiro Sintel", link: "https://api.whatsapp.com/send?phone=5581988179652/" },
    { src: "/Images/Parceiros/Certificado.digital.png", alt: "Certificado Digital", link: "/parceiro-certificacao-digital" },
    { src: "/Images/Parceiros/Hotmart.png", alt: "Parceiro Hotmart", link: "https://bit.ly/3Pynts7" },
    { src: "/Images/Parceiros/Pedro-Eurico.png", alt: "Pedro Eurico", link: "#" },
    { src: "/Images/Parceiros/Everso.png", alt: "Everso", link: "https://bit.ly/3LbdnuP" },
    { src: "/Images/Parceiros/Nebl-cuida-de-voce.png", alt: "Nebl Planos", link: "https://www.instagram.com/nebl_planosdesaude/" },
    { src: "/Images/Parceiros/Arena-Society.png", alt: "Arena Society", link: "https://www.instagram.com/arena_society_erasme_lins/" },
    { src: "/Images/Parceiros/Vargas.png", alt: "Vargas", link: "http://bit.ly/3UN1KNb" },
    { src: "/Images/Parceiros/Holder.png", alt: "Holder", link: "#" },
    { src: "/Images/Parceiros/Nisia-planos-de-saude.png", alt: "Nisia Planos", link: "https://www.instagram.com/nisia.vasconcelos/" },
    { src: "/Images/Parceiros/Sergio.png", alt: "AWS", link: "#" },
    { src: "/Images/Parceiros/potencia-solucoes.png", alt: "Potência Soluções", link: "#" },
    { src: "/Images/Parceiros/enovicertificado.png", alt: "Enovi Certificado", link: "https://api.whatsapp.com/send/?phone=5581996584830&text&app_absent=0" },
    { src: "/Images/Parceiros/Ma-eltrica.png", alt: "Ma Elétrica", link: "https://api.whatsapp.com/send?phone=5581987165260/" },
    { src: "/Images/Parceiros/ImperioDescartaveis.png", alt: "Imperio Descartáveis", link: "https://www.instagram.com/imperiodosdescartaveisstore/" },
    { src: "/Images/Parceiros/Issoebom.png", alt: "Isso é Bom", link: "https://bit.ly/44EOTkq" },
    { src: "/Images/Parceiros/Gomes-Figueredo.png", alt: "Gomes Figueredo", link: "https://bit.ly/3P9LiVA" },
    { src: "/Images/Parceiros/OGS.png", alt: "OGS", link: "https://api.whatsapp.com/send?phone=5581998753986" },
    { src: "/Images/Parceiros/Diniz-contabilidade.png", alt: "Diniz Contabilidade", link: "https://api.whatsapp.com/send?phone=5581997780156" },
    { src: "/Images/Parceiros/JH.png", alt: "JH", link: "https://api.whatsapp.com/send?phone=5581988823062" },
    { src: "/Images/Parceiros/ArouchaGas.png", alt: "Aroucha Gás", link: "https://bit.ly/45QenfI" },
    { src: "/Images/Parceiros/Osayk.png", alt: "Osayk", link: "https://osayk.com.br/" },
    { src: "/Images/Parceiros/GitHub.png", alt: "GitHub", link: "https://github.com/" },
    { src: "/Images/Parceiros/JoseJeronimo.png", alt: "JoseJeronimo", link: "#" },    
    { src: "/Images/Parceiros/AWS.png", alt: "AWS", link: "https://aws.amazon.com/pt/" },
    { src: "/Images/Parceiros/Fisconet.png", alt: "Fisconet", link: "https://bit.ly/3FzNu4w" }
];

function Parceiros() {
    return (
        <section id="parceiros">
            <div className="parceiros-container">
                <div className="parceiros-slider">
                    <div className="parceiros-track">
                        {parceiros.concat(parceiros).map((parceiro, index) => (
                            <a key={index} href={parceiro.link} target="_blank" rel="noopener noreferrer">
                                <img src={parceiro.src} alt={parceiro.alt} />
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Parceiros;